import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TimeInterval } from 'src/app/shop/entities/timeInterval';
import { TimeSlot } from 'src/app/shop/entities/timeSlot';
import { DualListComponent } from '../dual-list/dual-list.component';
import { DeliveryTimeService } from '../services/delivery-times.service';

@Component({
  selector: 'app-edit-collection',
  templateUrl: './edit-collection.component.html',
  styleUrls: ['./edit-collection.component.scss']
})
export class EditCollectionComponent implements OnInit {

  currentDay: number;

  constructor(private formBuilder: FormBuilder, private deliveryTimesService: DeliveryTimeService) { }

  saving: boolean = false;

  deliveryTimes: Array<TimeSlot> = new Array<TimeSlot>();

  key: string = 'id';

  successfullySaved: boolean = false;
  errorOnSave: boolean = false;

  deliveryLeadTime: string;
  errorOnLeadTimeSave: boolean = false;
  successfullySavedLeadTime: boolean = false;
  savingLeadTime: boolean;

  dayList: any[] = [
    {day: 1, title: 'Monday'},
    {day: 2, title: 'Tuesday'},
    {day: 3, title: 'Wednesday'},
    {day: 4, title: 'Thursday'},
    {day: 5, title: 'Friday'},
    {day: 6, title: 'Saturday'},
    {day: 0, title: 'Sunday'},
  ];

  filter = false;
  keepSorted = true;
  sourceLeft = true;
  format: any = DualListComponent.DEFAULT_FORMAT;
  confirmed: Array<any> = new Array<any>();
  disabled = false;
  display: string = 'time';
  activeList: Array<TimeSlot> = new Array<TimeSlot>();
  dateForm: FormGroup;
  currentDateString: string;
  showShopClosedError: boolean = false;

  ngOnInit(): void {

    this.dateForm = this.formBuilder.group({
      date: ['']
    })

    this.deliveryTimesService.getLeadTimeCollection().subscribe(x => {
      this.deliveryLeadTime = x;
    })

    const d = new Date();
    let day = d.getDay();
    this.currentDay = day;

    this.dateForm.get("date").valueChanges.subscribe(x => {
      if (!!this.dateForm.get("date").value) {
        this.showShopClosedError = false;
        this.confirmed = new Array<TimeSlot>();
        var date = new Date(this.dateForm.get("date").value);
        const yy = new Date(date).getFullYear();
        const mm = new Date(date).getMonth() + 1;
        const dd = new Date(date).getDate();

        this.currentDateString = `${dd}-${mm}-${yy}`
        this.deliveryTimesService.getEditableDeliveryTimes(false, date.getDay()).subscribe(x => {
          this.deliveryTimes = x;
          var allDisabledDateSlots = this.deliveryTimes.map(x => x.disabledDateSlots);
          var i = 0;
          allDisabledDateSlots.forEach(x => {
            var matchingDates = x.filter(x => new Date(x.disableDateTime).getDate() == date.getDate());
            if (!!matchingDates && matchingDates.length > 0)
            {
              this.confirmed = this.confirmed.concat(this.deliveryTimes[i]);
            }
            i++;
          })
          this.doReset();
        },
        (error) => {
          if (error.status == '513')
          {
            this.showShopClosedError = true;
          }
        })

      }
    });

    this.dateForm.get('date').setValue(new Date());
  }

  doReset() {
    this.activeList = this.deliveryTimes.filter(x => !this.confirmed.includes(x));
    this.useDeliveryTimes();
  }

  private useDeliveryTimes() {
    this.key = 'id';
    this.display = 'time';
    this.keepSorted = true;
  }

  swapDirection() {
    this.sourceLeft = !this.sourceLeft;
    this.format.direction = this.sourceLeft ? DualListComponent.LTR : DualListComponent.RTL;
  }

  doDisable() {
    this.disabled = !this.disabled;
  }

  filterBtn() {
    return (this.filter ? 'Hide Filter' : 'Show Filter');
  }

  disableBtn() {
    return (this.disabled ? 'Enable' : 'Disabled');
  }

  public save() {
    this.saving = true;
    this.successfullySaved = false;
    this.errorOnSave = false;

    this.deliveryTimesService.updateDeliveryTimes(this.confirmed, this.currentDateString, false).subscribe(x => {
      this.saving = false;
      this.errorOnSave = false;
      this.successfullySaved = true;
    },
     (error) => {
      this.saving = false;
      this.successfullySaved = false;
      this.errorOnSave = true;
     })
  }

  setActiveList(event: any) {
    this.successfullySaved = false;
    this.errorOnSave = false;

    this.activeList = new Array<TimeSlot>();
    var eventIds = event.map(x => x._id);

    if (!!eventIds && eventIds.length > 0) {
      for (let i = 0; i < eventIds.length; i++) {
        var timeInterval = this.deliveryTimes.find(x => x.id == eventIds[i]);
        if (!!timeInterval)
        {
          this.activeList.push(timeInterval);
        }
      }
    }
  }

  changeDay(event: any)
  {
    this.successfullySaved = false;
    this.errorOnSave = false;
    this.deliveryTimesService.getEditableDeliveryTimes(false, event.value).subscribe(x => {
      this.deliveryTimes = x;
      this.doReset();
    })
  }

  public saveLeadTime() {
    this.savingLeadTime = true;
    this.successfullySavedLeadTime = false;
    this.errorOnLeadTimeSave = false;

    this.deliveryTimesService.setCollectionLeadTime(this.deliveryLeadTime.toString()).subscribe(x => {
      this.savingLeadTime = false;
      this.errorOnLeadTimeSave = false;
      this.successfullySavedLeadTime = true;
    },
     (error) => {
      this.savingLeadTime = false;
      this.successfullySavedLeadTime = false;
      this.errorOnLeadTimeSave = true;
     })
  }

}
